import { FILTER_IS_LOADING } from "./types/filter";

export function setFilterIsLoading(bool) {
    return {
        type: FILTER_IS_LOADING,
        isLoading: bool
    };
}